<template>
    <v-flex xs6 sm3 md2 lg1 class="pa-2">
        <router-link :to="{ name: 'document-add', params: { slug: currentDirectory.slug }}">
            <v-card class="pointer flexcard" height="100%">
                <v-card-title class="justify-center grow">
                    <v-icon color="grey darken-3"  class="tile-icon">add_photo_alternate</v-icon>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-actions
                    class="pa-3 font-weight-medium text-truncate justify-center">
                    Ajout documents
                </v-card-actions>
            </v-card>
        </router-link>
    </v-flex>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "DocumentAdd",
        computed: {
            ...mapGetters(["currentDirectory"])
        }
    };
</script>

<style scoped lang="scss">
</style>
